import { useEffect } from 'react';
import type { Map as MapboxMap } from 'mapbox-gl';
import { useMapStore } from '../../../stores/mapStore';

const ROAD_EXIT_LAYER = 'road-exit-shield';

/** Ensure motorway junction exit icons render above labels and without ref-only filter. */
export function useMotorwayJunctionLayer(
  mapRef: React.MutableRefObject<MapboxMap | null>,
) {
  const { isMapLoaded } = useMapStore();

  useEffect(() => {
    const map = mapRef.current;
    if (!map || !isMapLoaded) return;

    const apply = () => {
      const activeMap = mapRef.current;
      if (!activeMap?.getLayer(ROAD_EXIT_LAYER)) return;
      activeMap.setFilter(ROAD_EXIT_LAYER, null);
      activeMap.setLayoutProperty(ROAD_EXIT_LAYER, 'icon-allow-overlap', true);
      activeMap.setLayoutProperty(ROAD_EXIT_LAYER, 'icon-ignore-placement', true);
      activeMap.setLayoutProperty(ROAD_EXIT_LAYER, 'icon-padding', 0);
      activeMap.setLayoutProperty(ROAD_EXIT_LAYER, 'text-optional', true);
      activeMap.setLayoutProperty(ROAD_EXIT_LAYER, 'text-field', [
        'coalesce',
        ['get', 'ref'],
        ['get', 'name'],
      ]);
      try {
        activeMap.moveLayer(ROAD_EXIT_LAYER);
      } catch {
        // Layer may not exist yet during style transitions.
      }
    };

    apply();
    map.on('style.load', apply);
    return () => {
      map.off('style.load', apply);
    };
  }, [mapRef, isMapLoaded]);
}
